"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewInitiator = exports.ReviewStatusChangedByType = exports.ReviewShortcut = exports.ReviewActivity = exports.ReviewStatus = void 0;
var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["NOT_REQUIRED"] = "NOT_REQUIRED";
    ReviewStatus["NOT_SET"] = "NOT_SET";
    ReviewStatus["WAITING_FOR_REVIEWER"] = "WAITING_FOR_REVIEWER";
    ReviewStatus["WAITING_FOR_EXPENSE_OWNER"] = "WAITING_FOR_EXPENSE_OWNER";
    ReviewStatus["OK"] = "OK";
    ReviewStatus["NOT_OK"] = "NOT_OK";
})(ReviewStatus = exports.ReviewStatus || (exports.ReviewStatus = {}));
var ReviewActivity;
(function (ReviewActivity) {
    ReviewActivity["SEEN"] = "SEEN";
})(ReviewActivity = exports.ReviewActivity || (exports.ReviewActivity = {}));
var ReviewShortcut;
(function (ReviewShortcut) {
    ReviewShortcut["ABOVE_BUDGET"] = "ABOVE_BUDGET";
    ReviewShortcut["CATEGORY_MISSING"] = "CATEGORY_MISSING";
    ReviewShortcut["MILEAGE_WRONG"] = "MILEAGE_WRONG";
    ReviewShortcut["NOTE_MISSING"] = "NOTE_MISSING";
    ReviewShortcut["NOT_BUSINESS_EXPENSE"] = "NOT_BUSINESS_EXPENSE";
    ReviewShortcut["RECEIPT_INVALID"] = "RECEIPT_INVALID";
    ReviewShortcut["RECEIPT_MISSING"] = "RECEIPT_MISSING";
})(ReviewShortcut = exports.ReviewShortcut || (exports.ReviewShortcut = {}));
var ReviewStatusChangedByType;
(function (ReviewStatusChangedByType) {
    ReviewStatusChangedByType["EMPLOYEE"] = "EMPLOYEE";
    ReviewStatusChangedByType["SYSTEM"] = "SYSTEM";
    ReviewStatusChangedByType["BOOKKEEPER"] = "BOOKKEEPER";
})(ReviewStatusChangedByType = exports.ReviewStatusChangedByType || (exports.ReviewStatusChangedByType = {}));
var ReviewInitiator;
(function (ReviewInitiator) {
    ReviewInitiator["COMPANY"] = "COMPANY";
    ReviewInitiator["TEAM"] = "TEAM";
    ReviewInitiator["USER"] = "USER";
})(ReviewInitiator = exports.ReviewInitiator || (exports.ReviewInitiator = {}));
//# sourceMappingURL=expense-review.js.map